export default __webpack_public_path__ + "static/media/background.d0ad979b.jpg";